import { AnimatePresence } from 'framer-motion'
import { AlgoliaSearchProvider } from '@components/AlgoliaSearch/AlgoliaSearchProvider'
import type { MinisearchData } from '@velasca/types'
import * as S from './Minisearch.styles'
import { MinisearchContent } from './MinisearchContent'

export const Minisearch = ({
  top,
  heightDelta,
  visible,
  onClose,
  data,
}: {
  visible: boolean
  onClose: () => void
  top: number
  heightDelta: number
  data: MinisearchData
}) => {
  return (
    <AlgoliaSearchProvider ignoreCollectionFilters searchActive routing={false}>
      <AnimatePresence>
        {visible && (
          <S.Minisearch
            role="dialog"
            aria-modal="true"
            aria-label="Search products"
            initial={{ height: 0, top: `${top}px` }}
            exit={{ height: 0, top: `${top}px` }}
            transition={{
              duration: 0.3,
              ease: [0.4, 0, 0.2, 1],
            }}
            animate={{
              height: `calc(100dvh - ${heightDelta}px)`,
            }}
          >
            <MinisearchContent data={data} onClose={onClose} />
          </S.Minisearch>
        )}
      </AnimatePresence>
    </AlgoliaSearchProvider>
  )
}
